import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/preChatActivity/StarterPromptsToolbar.module_built.css";
const classes = {"pre-chat-message-activity__card-action-toolbar":"wvd8n9G_pre-chat-message-activity__card-action-toolbar","pre-chat-message-activity__card-action-toolbar-grid":"wvd8n9G_pre-chat-message-activity__card-action-toolbar-grid"}
export default classes

const _pre_chat_message_activity__card_action_toolbar0 = classes["pre-chat-message-activity__card-action-toolbar"]
export { _pre_chat_message_activity__card_action_toolbar0 as "pre-chat-message-activity__card-action-toolbar" }

const _pre_chat_message_activity__card_action_toolbar_grid0 = classes["pre-chat-message-activity__card-action-toolbar-grid"]
export { _pre_chat_message_activity__card_action_toolbar_grid0 as "pre-chat-message-activity__card-action-toolbar-grid" }
